import React, { useEffect, useRef, useState } from 'react';
import MeniStan from './MeniStan';
import StanMeni2 from './StanMeni2';
import Podaci from './Podaci';
import slika1 from '../assets/slika1.jpeg';
import slika2 from '../assets/slika2.jpeg';
import slika3 from '../assets/slika3.jpeg';
import slika4 from '../assets/slika4.jpg';
import slika5 from '../assets/slika5.jpg';

const StanDetail = ({ stan, onBack, listingType,onSearch }) => {
  const topRef = useRef(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [selectedStan, setSelectedStan] = useState(stan); // Dodajemo state za selektovani stan

  const rentListings = [
    {
      id: 1,
      image: slika1,
      title: 'Novi Sad - Salajka',
      location: 'Novi Sad, Salajka',
      price: 450,
      area: 55,
      rooms: 2,
      type: 'Stan',
      date: '19/08/24',
      images: [slika1, slika2],
      sifra: 'A50-1601',
      kupatila: 1,
      parking: true,
      namena: 'Iznajmljivanje',
      garaza: 'Nema',
      spratovi: 3,
      namestenost: 'Namešten',
      drzava: 'Srbija',
      grad: 'Novi Sad',
      transakcija: 'Izdavanje',
      year: 2017,
    },
    {
      id: 2,
      image: slika2,
      title: 'Novi Sad - Adice',
      location: 'Novi Sad, Adice',
      price: 550,
      area: 60,
      rooms: 3,
      type: 'Stan',
      date: '20/08/24',
      images: [slika2, slika3],
      sifra: 'A50-1602',
      kupatila: 1,
      parking: true,
      namena: 'Iznajmljivanje',
      garaza: 'Nema',
      spratovi: 2,
      namestenost: 'Polunamešten',
      drzava: 'Srbija',
      grad: 'Novi Sad',
      transakcija: 'Izdavanje',
      year: 2018,
    },
    {
      id: 3,
      image: slika3,
      title: 'Beograd - Zemun',
      location: 'Beograd, Zemun',
      price: 700,
      area: 75,
      rooms: 4,
      type: 'Kuća',
      date: '20/08/24',
      images: [slika3, slika4],
      sifra: 'A50-1603',
      kupatila: 2,
      parking: true,
      namena: 'Iznajmljivanje',
      garaza: 'Da',
      spratovi: 1,
      namestenost: 'Prazan',
      drzava: 'Srbija',
      grad: 'Beograd',
      transakcija: 'Izdavanje',
      year: 2019,
    },
    {
      id: 4,
      image: slika4,
      title: 'Novi Sad - Grbavica',
      location: 'Novi Sad, Grbavica',
      price: 400,
      area: 50,
      rooms: 2,
      type: 'Stan',
      date: '19/08/24',
      images: [slika4, slika5],
      sifra: 'A50-1604',
      kupatila: 1,
      parking: false,
      namena: 'Iznajmljivanje',
      garaza: 'Nema',
      spratovi: 4,
      namestenost: 'Namešten',
      drzava: 'Srbija',
      grad: 'Novi Sad',
      transakcija: 'Izdavanje',
      year: 2016,
    },
    {
      id: 5,
      image: slika1,
      title: 'Beograd - Voždovac',
      location: 'Beograd, Voždovac',
      price: 650,
      area: 70,
      rooms: 3,
      type: 'Stan',
      date: '21/08/24',
      images: [slika1, slika3],
      sifra: 'A50-1605',
      kupatila: 1,
      parking: true,
      namena: 'Iznajmljivanje',
      garaza: 'Nema',
      spratovi: 3,
      namestenost: 'Polunamešten',
      drzava: 'Srbija',
      grad: 'Beograd',
      transakcija: 'Izdavanje',
      year: 2017,
    },
    {
      id: 6,
      image: slika2,
      title: 'Novi Sad - Liman',
      location: 'Novi Sad, Liman',
      price: 500,
      area: 45,
      rooms: 2,
      type: 'Stan',
      date: '20/08/24',
      images: [slika2, slika3],
      sifra: 'A50-1606',
      kupatila: 1,
      parking: false,
      namena: 'Iznajmljivanje',
      garaza: 'Nema',
      spratovi: 5,
      namestenost: 'Namešten',
      drzava: 'Srbija',
      grad: 'Novi Sad',
      transakcija: 'Izdavanje',
      year: 2019,
    },
    {
      id: 7,
      image: slika3,
      title: 'Novi Sad - Podbara',
      location: 'Novi Sad, Podbara',
      price: 470,
      area: 60,
      rooms: 3,
      type: 'Stan',
      date: '21/08/24',
      images: [slika3, slika4],
      sifra: 'A50-1607',
      kupatila: 2,
      parking: true,
      namena: 'Iznajmljivanje',
      garaza: 'Da',
      spratovi: 2,
      namestenost: 'Prazan',
      drzava: 'Srbija',
      grad: 'Novi Sad',
      transakcija: 'Izdavanje',
      year: 2015,
    },
    {
      id: 8,
      image: slika4,
      title: 'Beograd - Novi Beograd',
      location: 'Beograd, Novi Beograd',
      price: 900,
      area: 100,
      rooms: 4,
      type: 'Stan',
      date: '22/08/24',
      images: [slika4, slika5],
      sifra: 'A50-1608',
      kupatila: 2,
      parking: true,
      namena: 'Iznajmljivanje',
      garaza: 'Da',
      spratovi: 6,
      namestenost: 'Polunamešten',
      drzava: 'Srbija',
      grad: 'Beograd',
      transakcija: 'Izdavanje',
      year: 2020,
    },
    {
      id: 9,
      image: slika1,
      title: 'Novi Sad - Sajmište',
      location: 'Novi Sad, Sajmište',
      price: 430,
      area: 50,
      rooms: 2,
      type: 'Stan',
      date: '23/08/24',
      images: [slika1, slika3],
      sifra: 'A50-1609',
      kupatila: 1,
      parking: false,
      namena: 'Iznajmljivanje',
      garaza: 'Nema',
      spratovi: 4,
      namestenost: 'Namešten',
      drzava: 'Srbija',
      grad: 'Novi Sad',
      transakcija: 'Izdavanje',
      year: 2018,
    },
    {
      id: 10,
      image: slika2,
      title: 'Beograd - Dorćol',
      location: 'Beograd, Dorćol',
      price: 1200,
      area: 85,
      rooms: 3,
      type: 'Stan',
      date: '23/08/24',
      images: [slika2, slika3],
      sifra: 'A50-1610',
      kupatila: 2,
      parking: true,
      namena: 'Iznajmljivanje',
      garaza: 'Da',
      spratovi: 5,
      namestenost: 'Namešten',
      drzava: 'Srbija',
      grad: 'Beograd',
      transakcija: 'Izdavanje',
      year: 2016,
    },
];

const saleListings = [
  {
    id: 1,
    image: slika3,
    title: 'Novi Sad - Telep',
    location: 'Novi Sad, Telep',
    price: 125000,
    area: 85,
    rooms: 3,
    type: 'Stan',
    date: '21/08/24',
    images: [slika3, slika4],
    sifra: 'B50-1701',
    kupatila: 2,
    parking: true,
    namena: 'Prodaja',
    garaza: 'Da',
    spratovi: 4,
    namestenost: 'Polunamešten',
    drzava: 'Srbija',
    grad: 'Novi Sad',
    transakcija: 'Prodaja',
    year: 2015,
  },
  {
    id: 2,
    image: slika4,
    title: 'Novi Sad - Podbara',
    location: 'Novi Sad, Podbara',
    price: 98000,
    area: 70,
    rooms: 2.5,
    type: 'Stan',
    date: '22/08/24',
    images: [slika4, slika5],
    sifra: 'B50-1702',
    kupatila: 1,
    parking: true,
    namena: 'Prodaja',
    garaza: 'Da',
    spratovi: 3,
    namestenost: 'Namešten',
    drzava: 'Srbija',
    grad: 'Novi Sad',
    transakcija: 'Prodaja',
    year: 2016,
  },
  {
    id: 3,
    image: slika1,
    title: 'Beograd - Vračar',
    location: 'Beograd, Vračar',
    price: 200000,
    area: 90,
    rooms: 4,
    type: 'Stan',
    date: '23/08/24',
    images: [slika1, slika2],
    sifra: 'B50-1703',
    kupatila: 2,
    parking: true,
    namena: 'Prodaja',
    garaza: 'Nema',
    spratovi: 5,
    namestenost: 'Namešten',
    drzava: 'Srbija',
    grad: 'Beograd',
    transakcija: 'Prodaja',
    year: 2021,
  },
  {
    id: 4,
    image: slika2,
    title: 'Novi Sad - Detelinara',
    location: 'Novi Sad, Detelinara',
    price: 85000,
    area: 60,
    rooms: 3,
    type: 'Stan',
    date: '23/08/24',
    images: [slika2, slika3],
    sifra: 'B50-1704',
    kupatila: 1,
    parking: true,
    namena: 'Prodaja',
    garaza: 'Nema',
    spratovi: 4,
    namestenost: 'Polunamešten',
    drzava: 'Srbija',
    grad: 'Novi Sad',
    transakcija: 'Prodaja',
    year: 2017,
  },
  {
    id: 5,
    image: slika3,
    title: 'Beograd - Zvezdara',
    location: 'Beograd, Zvezdara',
    price: 130000,
    area: 75,
    rooms: 3,
    type: 'Stan',
    date: '24/08/24',
    images: [slika3, slika4],
    sifra: 'B50-1705',
    kupatila: 2,
    parking: true,
    namena: 'Prodaja',
    garaza: 'Da',
    spratovi: 3,
    namestenost: 'Namešten',
    drzava: 'Srbija',
    grad: 'Beograd',
    transakcija: 'Prodaja',
    year: 2020,
  },
  {
    id: 6,
    image: slika4,
    title: 'Novi Sad - Liman',
    location: 'Novi Sad, Liman',
    price: 95000,
    area: 70,
    rooms: 2,
    type: 'Stan',
    date: '24/08/24',
    images: [slika4, slika5],
    sifra: 'B50-1706',
    kupatila: 1,
    parking: true,
    namena: 'Prodaja',
    garaza: 'Nema',
    spratovi: 2,
    namestenost: 'Polunamešten',
    drzava: 'Srbija',
    grad: 'Novi Sad',
    transakcija: 'Prodaja',
    year: 2018,
  },
  {
    id: 7,
    image: slika1,
    title: 'Beograd - Savski Venac',
    location: 'Beograd, Savski Venac',
    price: 300000,
    area: 150,
    rooms: 5,
    type: 'Kuća',
    date: '25/08/24',
    images: [slika1, slika2],
    sifra: 'B50-1707',
    kupatila: 3,
    parking: true,
    namena: 'Prodaja',
    garaza: 'Da',
    spratovi: 2,
    namestenost: 'Namešten',
    drzava: 'Srbija',
    grad: 'Beograd',
    transakcija: 'Prodaja',
    year: 2022,
  },
  {
    id: 8,
    image: slika2,
    title: 'Novi Sad - Novo Naselje',
    location: 'Novi Sad, Novo Naselje',
    price: 110000,
    area: 85,
    rooms: 4,
    type: 'Stan',
    date: '26/08/24',
    images: [slika2, slika3],
    sifra: 'B50-1708',
    kupatila: 2,
    parking: true,
    namena: 'Prodaja',
    garaza: 'Nema',
    spratovi: 3,
    namestenost: 'Polunamešten',
    drzava: 'Srbija',
    grad: 'Novi Sad',
    transakcija: 'Prodaja',
    year: 2019,
  },
  {
    id: 9,
    image: slika3,
    title: 'Beograd - Dedinje',
    location: 'Beograd, Dedinje',
    price: 450000,
    area: 250,
    rooms: 6,
    type: 'Kuća',
    date: '27/08/24',
    images: [slika3, slika4],
    sifra: 'B50-1709',
    kupatila: 4,
    parking: true,
    namena: 'Prodaja',
    garaza: 'Da',
    spratovi: 2,
    namestenost: 'Namešten',
    drzava: 'Srbija',
    grad: 'Beograd',
    transakcija: 'Prodaja',
    year: 2020,
  },
  {
    id: 10,
    image: slika4,
    title: 'Novi Sad - Petrovaradin',
    location: 'Novi Sad, Petrovaradin',
    price: 135000,
    area: 90,
    rooms: 4,
    type: 'Stan',
    date: '27/08/24',
    images: [slika4, slika5],
    sifra: 'B50-1710',
    kupatila: 2,
    parking: true,
    namena: 'Prodaja',
    garaza: 'Da',
    spratovi: 4,
    namestenost: 'Polunamešten',
    drzava: 'Srbija',
    grad: 'Novi Sad',
    transakcija: 'Prodaja',
    year: 2019,
  },
];

const handleSearchResults = (filteredResults) => {
  onSearch(filteredResults); // Poziv funkcije iz `App.js`
};

  useEffect(() => {
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [selectedStan]); // Skrolujemo na vrh kad god se promeni selektovani stan

  const handlePrevImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? selectedStan.images.length - 1 : prevIndex - 1
    );
  };

  const handleNextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === selectedStan.images.length - 1 ? 0 : prevIndex + 1
    );
  };

  // Funkcija koja će prikazati novi stan kada se klikne na stan iz StanMeni2
  const handleStanClickFromStanMeni2 = (newStan) => {
    setSelectedStan(newStan); // Postavljamo novi selektovani stan
  };

  const listingsToDisplay = listingType === 'iznajmljivanje' ? rentListings : saleListings;

  return (
    <div ref={topRef} className="w-full min-h-screen bg-gray-900 text-white">
      <h1 className="text-3xl font-bold text-center text-white pt-12">
        M
      </h1>

      <div className="flex flex-col lg:flex-row p-8">
        <div className="w-full lg:w-2/5 flex flex-col items-start lg:ml-16 pt-8">
          <div className="w-full text-left mb-4">
            <h3 className="text-xl font-semibold text-white mb-4">
              {selectedStan.location}
            </h3>
          </div>

          <div className="relative w-full h-[calc(100vh-200px)] border-2 border-pink-600 shadow-lg rounded-lg">
            <img
              src={selectedStan.images[currentImageIndex]}
              alt={`Stan ${currentImageIndex + 1}`}
              className="w-full h-full object-cover rounded-lg"
              style={{ boxShadow: '0 0 20px 4px rgba(225, 0, 85, 0.8)' }}
            />
            <button
              onClick={handlePrevImage}
              className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-transparent text-white px-3 py-1.5 rounded-none hover:text-black hover:border-pink-600 hover:border"
            >
              ←
            </button>
            <button
              onClick={handleNextImage}
              className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-transparent text-white px-3 py-1.5 rounded-none hover:text-black hover:border-pink-600 hover:border"
            >
              →
            </button>
          </div>

          <div className="flex justify-center mt-3 space-x-3 w-full">
            {selectedStan.images.map((_, index) => (
              <button
                key={index}
                className={`w-3 h-3 rounded-full ${index === currentImageIndex ? 'bg-pink-600' : 'bg-gray-500'}`}
                onClick={() => setCurrentImageIndex(index)}
              ></button>
            ))}
          </div>

          <div className="mt-3 p-6 bg-gray-800 rounded-lg shadow-md w-full">
            <p className="text-gray-300 text-sm">
              Ovaj stan se nalazi na lokaciji {selectedStan.location}. Sadrži {selectedStan.rooms} soba i ima površinu od {selectedStan.area} m². 
              Cena stana je €{selectedStan.price}. Tip nekretnine je {selectedStan.type}. Stan je izgrađen {selectedStan.year}. 
              Savršen je za porodice ili mlade parove koji traže moderan stan sa odličnim rasporedom.
            </p>
          </div>
          <div className="w-full mt-16">
            <MeniStan onFilter={handleSearchResults} /> {/* Dodato */}
          </div>

          <div className="text-left mt-6">
            <button
              onClick={onBack}
              className="bg-pink-800 text-white py-2 px-6  rounded-lg hover:bg-pink-700 hover:text-black transition-colors duration-300"
            >
              Vrati se nazad
            </button>
          </div>
        </div>

        <div className="flex-grow lg:w-2/5 lg:ml-20 flex flex-col lg:mt-0">
          <div className="flex-grow pt-24">
            <Podaci 
              sifra={selectedStan.sifra}
              tip={selectedStan.type}
              cena={selectedStan.price}
              kvadratura={selectedStan.area}
              sobe={selectedStan.rooms}
              kupatila={selectedStan.kupatila || 1} 
              parking={selectedStan.parking || true}
              namena={selectedStan.namena || 'Prodaja'}
              garaza={selectedStan.garaza || 'Nema'}
              spratovi={selectedStan.spratovi || 1}
              namestenost={selectedStan.namestenost || 'Namešten'}
            />
          
            <div className="mt-20">
              <StanMeni2 listings={listingsToDisplay} onStanClick={handleStanClickFromStanMeni2} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StanDetail;
